<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        :title="$t('storeList.add.dialogTitle')"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="addForm" :model="addForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('storeList.add.platform_id')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.add.selectPlaceholder'
                                    )}${$t('storeList.add.platform_id')}`,
                                },
                            ]"
                            prop="platform_id"
                            size="small"
                        >
                            <img class="store-img" :src="storeImgSrc" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('storeList.add.name')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.add.inputPlaceholder'
                                    )}${$t('storeList.add.name')}`,
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'storeList.add.inputPlaceholder'
                                )}${$t('storeList.add.name')}`"
                                maxlength="100"
                                size="small"
                                v-model="addForm.name"
                            ></el-input>
                            <el-tooltip class="item" effect="light" content="Store name may be used for order filtering." placement="right"><i class="el-info el-icon-info"></i></el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item 
                        :label="$t('storeList.add.shop_url')" 
                        :rules="[
                            {
                                required: true,
                                message: 'Please input Shop Url',
                            },
                        ]"
                        prop="shop_url"
                        size="small">
                            <el-input
                                clearable
                                placeholder="Please input Shop Url"
                                maxlength="100"
                                v-model="addForm.shop_url"
                                size="small"
                            >
                                <template slot="prepend">https://</template>
                                <template slot="append" v-if="[3,4,8].includes(addForm.platform_id)">.{{{3:'myshopify',4:'myshoplaza',8:'myshopline'}[addForm.platform_id]}}.com</template>
                            </el-input>
                            <el-tooltip class="item" effect="light" content="Make sure store url is correct before authorization." placement="right"><i class="el-info el-icon-info"></i></el-tooltip>
                        </el-form-item>
                    </el-col>
                    <template v-if="[3,4,8,9].includes(addForm.platform_id)">
                    <el-col :span="24">
                        <el-form-item label="Sync Order" size="small">
                            <el-radio-group v-model="addForm.sync_order">
                            <el-radio label="1">Yes</el-radio>
                            <el-radio label="0">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="App Type" size="small">
                            <el-radio-group v-model="addForm.auth_type">
                            <el-radio label="3">App</el-radio>
                            <el-radio label="1" v-if="addForm.platform_id === 3">Private</el-radio>
                            <el-radio label="2" v-if="addForm.platform_id === 3">Custom</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="addForm.auth_type === '1'">
                        <el-form-item
                            label="Appid"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Appid',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Appid"
                                maxlength="100"
                                size="small"
                                v-model="addForm.appid"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="addForm.auth_type === '1'">
                        <el-form-item
                            label="Secret"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Secret',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Secret"
                                maxlength="100"
                                size="small"
                                v-model="addForm.secret"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="addForm.auth_type === '2'">
                        <el-form-item
                            label="Access Token"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Access Token',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Access Token"
                                maxlength="100"
                                size="small"
                                v-model="addForm.access_token"
                            ></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <h3 style="padding: 10px 0 20px 0;">Customized Option <el-tooltip class="item" effect="light" content="Make sure store url is correct before authorization." placement="right"><i class="el-info el-icon-info"></i></el-tooltip></h3>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item class="customized" label="Customized Field" size="small">
                            <el-radio-group v-model="addForm.customized">
                            <el-radio label="1">Yes</el-radio>
                            <el-radio label="0">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item class="customized"
                            label="Customized Field Language"
                            size="small"
                            prop="lang"
                        >
                            <el-select
                                v-model="addForm.lang"
                                size="mini"
                                placeholder="Please select"
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="item in languages"
                                    :key="item.id"
                                    :label="item.lang"
                                    :value="item.code"
                                ></el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    </template>

                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save(1)"
                :loading="authLoading"
                v-if="[3,4,8,9].includes(addForm.platform_id) && addForm.auth_type == 3"
            >Authorize</el-button>
            <el-button
                size="small"
                type="primary"
                @click="save(0)"
                :loading="loading"
            >{{ $t("storeList.add.save") }}</el-button>
            <el-button size="small" @click="addVisible = false">
                {{
                $t("storeList.add.close")
                }}
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    inject: ["saleUserList"],
    data() {
        return {
            addForm: {
                name: "",
                platform_id: "",
                shop_url: "",
                sync_order: "1",
                auth_type: '3',
                appid: "",
                secret: "",
                access_token: "",
                customized:"1",
                track_id: "",
                customer_ids: [],
                customer_email: "",
                lang:"en",
                type:0
            },
            platformList: [],
            languages: [],
            loading: false,
            authLoading:false,
            storeImgSrc: ""
        };
    },
    methods: {

        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            this.loading = true;
            cmofferApi.platformSelect({}, "get").then(res => {
                if (res) {
                    this.platformList = res.data;
                    this.languages = res.languages;
                    this.loading = false;
                    this.platformList.map(item => {
                        if (this.addForm.platform_id == item.id) {
                            this.storeImgSrc = require(`@/assets/image/store/${item.code}.png`);
                        }
                    });
                }
            });
        },
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.addForm = {
                name: "",
                platform_id: "",
                shop_url: "",
                sync_order: "1",
                auth_type: "3",
                appid: "",
                secret: "",
                access_token: "",
                customized:"1",
                track_id: "",
                customer_ids: [],
                customer_email: "",
                lang:"en",
                type:0
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        /**
         * 新增成功后窗口关闭
         */
        successCloseDialog(row) {
            this.$emit("successCloseDialog", row);
            this.closeDialog();
        },
        /**
         *  保存
         */
        save(type) {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    if(type == 0){
                        this.loading = true;
                    }else{
                        this.authLoading = true;
                    }
                    this.addForm.type = type;
            
                    cmofferApi.shop({ ...this.addForm, user_id: this.user_id }, "post").then(res => {
                        if (res) {
                            if(type == 1){
                                res.data.status && window.open(res.data.url);
                                this.$confirm(
                                    "Whether the store has been authorized.",
                                    "Authorization status",
                                    {
                                        confirmButtonText: "Success",
                                        cancelButtonText: "Fail",
                                        customClass: "auth-message-box",
                                    }
                                )
                                    .then(() => {
                                        //this.closeDialog();
                                        this.$parent.$parent.shop && this.$parent.$parent.shop();
                                        this.successCloseDialog(res.data);
                                    })
                                    .catch(() => { });
                            }else{
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.successCloseDialog(res.data);
                                this.saleUserList && this.saleUserList();
                                // this.$parent.shop && this.$parent.shop();
                                //console.log(this.$parent.$parent);
                                this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.myStoreList && this.$parent.$parent.$parent.myStoreList(1, this.user_id);
                            }
                            
                        }
                        if(type == 0){
                            this.loading = false;
                        }else{
                            this.authLoading = false;
                        }
                    });
                }
            });
        }
    },
    props: {
        addVisible: Boolean,
        id: Number,
        uuid: Number,
        user_id: Number,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.addForm.platform_id = this.id;
                    this.platformSelect();
                    this.addForm.track_id = this.userInfo.id
                        ? this.userInfo.id
                        : "";
                }
            },
            immediate: false,
            deep: true
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.login.userInfo;
        },
        ebayRule() {
            if (this.addForm.platform_id == 2) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
        .el-input{
            padding-right: 10px;
            width: calc(100% - 50px);
        }
        .el-input-group__prepend, .el-input-group__append {
            border-radius: 0;
            padding: 0 7px !important;
            // width: 100px;
            // color: #666;
            text-align: center;
        }
        .store-img {
            width: 35px;
            // height: 30px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }

        .el-input__suffix {
            right: 12px;
        }
    }
    .tip {
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        margin-bottom: 20px;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
    .el-col {
        padding-left: 20px!important;
        padding-right: 20px!important;

        .el-info {
            font-size: 18px;
            &.check {
                color: $color-primary;
            }
        }

        .customized {
            .el-form-item__label {
                width: auto!important;
            }
        }
    }
}
</style>
